import React, { useRef } from 'react'
import L from 'leaflet'
import { Map as CoreMap, TileLayer, Marker, Popup } from 'react-leaflet'
import { colorIcons } from './colors'

// START WORKAROUND FOR CSS IMPORT NOT WORKING FOR LEAFLET
delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('./icons/marker-icon-2x-black.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});
// END WORKAROUND FOR CSS IMPORT NOT WORKING FOR LEAFLET

// Houston Lat / Long
const position = [29.7604, -95.3698]


export const Map = ({ zoom = 9, center = { position }, height = "500px", width = "500px", markers = [] }) => {
    const mapRef = useRef(null)

    const closeCurrentPopup = () => {
        mapRef.current.leafletElement.closePopup()
    }
    

    return (
        <CoreMap center={center} zoom={zoom} style={{ height: height, width: width, zIndex: 0 }} ref={mapRef} tap={false}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            />
            {markers.map((m, idx) => {
                let color = colorIcons[m.markerColor] || colorIcons['default']
                return (
                    <Marker position={m.position} key={idx} icon={color}>
                        <Popup>
                            {React.cloneElement(m.children, { closeCurrentPopup: closeCurrentPopup })}
                        </Popup>
                    </Marker>)
            })
            }

        </CoreMap>
    )
}